import Index from './index.vue'

export default {
  name: 'jobList',
  path: '/v-admin/job-list',
  component: Index,
  meta: {
    isInclude: true,
    permission: ['PERM_JOB_GET'],
    titleI18nKey: 'admin.job.list.title'
  }
}
